import React, { useContext } from "react";
// import { Link } from "react-router-dom";
import { NavMenu } from "../../../shared/layout/menu/Menu";
import { Link, useNavigate } from "react-router-dom";
import AuthContext from "./../../../shared/services/providers/auth.context";
const AdminSideBar = () => {
  const authCtx = useContext(AuthContext);
  const navigate = useNavigate();
  const onLogout = () => {
    if (window.confirm("Are you sure you want to logout?")) {
      authCtx.logOut();
      sessionStorage.clear();
      navigate("/home");
      window.location.replace("/home");
    }
  };
  const navLinks = [
    {
      name: "Home",
      url: "/admin/home",
    },
    {
      name: "Images",
      url: "/admin/images",
    },
    {
      name: "Personal Info",
      url: "/admin/personalinfo",
    },
    {
      name: "Skills",
      url: "/admin/skill",
    },
    {
      name: "Projects",
      url: "/admin/projects",
    },
    {
      name: "Message",
      url: "/admin/message",
    },
    {
      name: "Social Media",
      url: "/admin/socialmedia",
    },
    {
      name: "Users",
      url: "/admin/users",
    },
    {
      name: "Upload Resume",
      url: "/admin/resume",
    },
    {
      name: "Accounts",
      url: "/admin/accounts",
    },
  ];
  return (
    <React.Fragment>
      <div className="sidebar">
        {navLinks.map((x) => {
          return <NavMenu key={x.name} data={x}></NavMenu>;
        })}

        <div className="mt-2 mb-2">
          <button
            onClick={onLogout}
            className="btn btn-outline-danger my-2 my-sm-0 w-100 mt-3"
            type="button"
          >
            Logout
          </button>
        </div>
      </div>
    </React.Fragment>
  );
};
export { AdminSideBar };
